// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCard\ApiCoordinationCardVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Coordination, CoordinationData, CoordinationOptions } from 'data/models/Coordination';
import { CoordinationCardSelf, CoordinationCardSelfData, CoordinationCardSelfOptions } from 'data/models/CoordinationCardSelf';
import { CoordinationCardStatus, CoordinationCardStatusData, CoordinationCardStatusOptions } from 'data/models/CoordinationCardStatus';
import { CoordinationCardVersion as _CoordinationCardVersion, CoordinationCardVersionData as _CoordinationCardVersionData, CoordinationCardVersionOptions as _CoordinationCardVersionOptions } from 'data/models/CoordinationCardVersion';
import { CoordinationProvider, CoordinationProviderData, CoordinationProviderOptions } from 'data/models/CoordinationProvider';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { ScheduleDateSelf, ScheduleDateSelfData, ScheduleDateSelfOptions } from 'data/models/ScheduleDateSelf';

// CoordinationCardVersionData is the class that CoordinationCardVersion serializes to/from
export interface CoordinationCardVersionData {
    ChangeId : number;
    Id : number;
	
    Change : ChangeData | null;
    Coordination : CoordinationData | null;
    CoordinationId : number;
    EventsAbout : EventData[] | null;
    EventsReferencing : EventData[] | null;
    NextVersion : _CoordinationCardVersionData[] | null;
    PrevChange : ChangeData | null;
    PrevChangeId : number | null;
    PrevVersion : _CoordinationCardVersionData | null;
    Provider : CoordinationProviderData | null;
    ProviderId : number;
    ScheduleDate : ScheduleDateSelfData | null;
    ScheduleDateId : number;
    Self : CoordinationCardSelfData | null;
    Status : CoordinationCardStatusData | null;
    StatusId : number;
	
    Deleted : boolean;
    StatusReason : string | null;
}

// CoordinationCardVersionOptions is the class which may be passed to the CoordinationCardVersion constructor to define optional initial data values
export interface CoordinationCardVersionOptions {
    ChangeId : number;
    Id : number;
	
    Change? : ChangeOptions | null;
    Coordination? : CoordinationOptions | null;
    CoordinationId? : number;
    EventsAbout? : EventOptions[] | null;
    EventsReferencing? : EventOptions[] | null;
    NextVersion? : _CoordinationCardVersionOptions[] | null;
    PrevChange? : ChangeOptions | null;
    PrevChangeId? : number | null;
    PrevVersion? : _CoordinationCardVersionOptions | null;
    Provider? : CoordinationProviderOptions | null;
    ProviderId? : number;
    ScheduleDate? : ScheduleDateSelfOptions | null;
    ScheduleDateId? : number;
    Self? : CoordinationCardSelfOptions | null;
    Status? : CoordinationCardStatusOptions | null;
    StatusId? : number;
	
    Deleted? : boolean;
    StatusReason? : string | null;
}

export class CoordinationCardVersion {
    public ChangeId : DataSignal<number>;
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public Coordination : DataSignal<Coordination | null>;
    public CoordinationId : DataSignal<number>;
    public EventsAbout : SDataArray<Event>;
    public EventsReferencing : SDataArray<Event>;
    public NextVersion : SDataArray<_CoordinationCardVersion>;
    public PrevChange : DataSignal<Change | null>;
    public PrevChangeId : DataSignal<number | null>;
    public PrevVersion : DataSignal<_CoordinationCardVersion | null>;
    public Provider : DataSignal<CoordinationProvider | null>;
    public ProviderId : DataSignal<number>;
    public ScheduleDate : DataSignal<ScheduleDateSelf | null>;
    public ScheduleDateId : DataSignal<number>;
    public Self : DataSignal<CoordinationCardSelf | null>;
    public Status : DataSignal<CoordinationCardStatus | null>;
    public StatusId : DataSignal<number>;
	
    public Deleted : DataSignal<boolean>;
    public StatusReason : DataSignal<string | null>;

    constructor();
    constructor(data : CoordinationCardVersionOptions);
    constructor(data: CoordinationCardVersionOptions | null = null) {
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.Coordination = S.value<Coordination | null>(null);
        this.CoordinationId = jsonableObservable(S.value<number>(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.EventsAbout = SArray<Event>([]);
        this.EventsReferencing = SArray<Event>([]);
        this.NextVersion = SArray<_CoordinationCardVersion>([]);
        this.PrevChange = S.value<Change | null>(null);
        this.PrevChangeId = jsonableObservable(S.value<number | null>(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = S.value<_CoordinationCardVersion | null>(null);
        this.Provider = S.value<CoordinationProvider | null>(null);
        this.ProviderId = jsonableObservable(S.value<number>(data && data.ProviderId !== undefined ? data.ProviderId : 0));
        this.ScheduleDate = S.value<ScheduleDateSelf | null>(null);
        this.ScheduleDateId = jsonableObservable(S.value<number>(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
        this.Self = S.value<CoordinationCardSelf | null>(null);
        this.Status = S.value<CoordinationCardStatus | null>(null);
        this.StatusId = jsonableObservable(S.value<number>(data && data.StatusId !== undefined ? data.StatusId : 0));
	    
        this.Deleted = jsonableObservable(S.value<boolean>(data && data.Deleted !== undefined ? data.Deleted : false));
        this.StatusReason = jsonableObservable(S.value<string | null>(data && data.StatusReason !== undefined ? data.StatusReason : null));
    }

    static key(obj : CoordinationCardVersion) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    }
    
    static dataKey(obj : CoordinationCardVersionOptions) {
        return obj.ChangeId + '\u2618' + obj.Id;
    }

    static update(obj : CoordinationCardVersion, data : CoordinationCardVersionOptions) {
        S.freeze(() => {
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.CoordinationId !== undefined) obj.CoordinationId(data.CoordinationId);
            if (data.PrevChangeId !== undefined) obj.PrevChangeId(data.PrevChangeId);
            if (data.ProviderId !== undefined) obj.ProviderId(data.ProviderId);
            if (data.ScheduleDateId !== undefined) obj.ScheduleDateId(data.ScheduleDateId);
            if (data.StatusId !== undefined) obj.StatusId(data.StatusId);
	        
            if (data.Deleted !== undefined) obj.Deleted(data.Deleted);
            if (data.StatusReason !== undefined) obj.StatusReason(data.StatusReason);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationCardVersion.ts